import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.detail');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-project-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.project.detail/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #f1f5f9;
}

.field-detail-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 80px);
}

.compact-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #ffffff;
  border-radius: 16px;
  padding: 14px 20px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.back-icon-btn {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: none;
  border-radius: 12px;
  color: #475569;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}
.back-icon-btn:hover {
  background: #2563eb;
  color: #fff;
}
.back-icon-btn:active {
  transform: scale(0.95);
}

.project-info {
  flex: 1;
  min-width: 0;
}

.project-name {
  font-size: 20px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: #f1f5f9;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}
.chip i {
  font-size: 6px;
}
.chip.chip-status.active {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
}
.chip.chip-status.active i {
  animation: pulse 1.5s infinite;
}
.chip.chip-status.pending {
  background: rgba(217, 119, 6, 0.15);
  color: #d97706;
}
.chip.chip-status.done {
  background: rgba(100, 116, 139, 0.15);
  color: #64748b;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.mini-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #f8fafc;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.mini-stat i {
  color: #ea580c;
  font-size: 14px;
}

.offline-cache-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.offline-cache-main {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.offline-cache-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #64748b;
}
.offline-cache-icon.completed {
  background: rgba(22, 163, 74, 0.12);
  color: #16a34a;
}
.offline-cache-icon.partial, .offline-cache-icon.syncing {
  background: rgba(217, 119, 6, 0.12);
  color: #d97706;
}
.offline-cache-icon.failed, .offline-cache-icon.missing {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.offline-cache-copy {
  min-width: 0;
}

.offline-cache-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 800;
  color: #1e293b;
}

.offline-cache-status {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
  background: #f1f5f9;
  color: #475569;
}
.offline-cache-status.completed {
  background: rgba(22, 163, 74, 0.12);
  color: #16a34a;
}
.offline-cache-status.partial, .offline-cache-status.syncing {
  background: rgba(217, 119, 6, 0.12);
  color: #d97706;
}
.offline-cache-status.failed, .offline-cache-status.missing {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.offline-cache-summary {
  margin-top: 4px;
  font-size: 13px;
  color: #475569;
}

.offline-cache-progress {
  height: 6px;
  margin-top: 10px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.offline-cache-progress-bar {
  height: 100%;
  min-width: 0;
  max-width: 100%;
  border-radius: 999px;
  background: #2563eb;
  transition: width 0.2s ease;
}

.offline-cache-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.offline-cache-size {
  font-size: 15px;
  font-weight: 800;
  color: #1e293b;
}

.offline-cache-updated {
  font-size: 12px;
  color: #64748b;
}

.offline-cache-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 0;
}

.cache-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.cache-action-btn.primary {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}
.cache-action-btn.detail-toggle {
  background: #f8fafc;
  color: #1e293b;
}
.cache-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.offline-cache-details {
  grid-column: 1/-1;
  display: grid;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.offline-cache-categories {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.offline-cache-category {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 12px;
}
.offline-cache-category .category-name {
  min-width: 0;
  color: #1e293b;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.offline-cache-category .category-state,
.offline-cache-category .category-size {
  color: #64748b;
  white-space: nowrap;
}

.offline-cache-missing,
.offline-cache-optional {
  margin-top: 12px;
  padding: 10px;
  border-radius: 8px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
}

.offline-cache-optional {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.offline-cache-details .offline-cache-categories,
.offline-cache-details .offline-cache-missing,
.offline-cache-details .offline-cache-optional {
  margin-top: 0;
}

.missing-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #d97706;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.optional-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.missing-list {
  display: grid;
  gap: 6px;
}

.missing-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: #1e293b;
}
.missing-item span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}
.missing-item small {
  color: #64748b;
  white-space: nowrap;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.facility-main-section {
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.facility-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr 1fr;
  gap: 16px;
  flex: 1;
  min-height: 400px;
}

.facility-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.facility-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 800;
  color: #1e293b;
}
.facility-title i {
  color: #2563eb;
  font-size: 20px;
}

.facility-pagination-info {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.page-btn {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.page-btn:hover:not(:disabled) {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}
.page-btn:active:not(:disabled) {
  transform: scale(0.95);
}
.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-numbers {
  display: flex;
  gap: 6px;
}

.page-num {
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #475569;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.page-num:hover:not(.active):not(.disabled) {
  background: #f1f5f9;
}
.page-num.active {
  background: #2563eb;
  color: #fff;
  font-weight: 700;
}
.page-num.disabled {
  opacity: 0.5;
  cursor: default;
}

.header-section {
  margin-bottom: 24px;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.back-btn:hover {
  background: #f8fafc;
  border-color: #2563eb;
  color: #2563eb;
}
.back-btn i {
  font-size: 14px;
}

.project-status .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
}
.project-status .status-badge.status-active {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
  border: 2px solid #16a34a;
}
.project-status .status-badge.status-active .pulse-dot {
  font-size: 8px;
  animation: pulse 1.5s infinite;
}
.project-status .status-badge.status-pending {
  background: rgba(217, 119, 6, 0.15);
  color: #d97706;
  border: 2px solid #d97706;
}
.project-status .status-badge.status-done {
  background: rgba(100, 116, 139, 0.15);
  color: #64748b;
  border: 2px solid #64748b;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.project-title-area {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.project-title {
  font-size: 28px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.project-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 15px;
}
.meta-item i {
  color: #64748b;
}

.meta-divider {
  color: #e2e8f0;
}

.quick-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.stat-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.stat-card.stat-category .stat-icon {
  background: rgba(217, 119, 6, 0.15);
  color: #d97706;
}
.stat-card.stat-period .stat-icon {
  background: rgba(37, 99, 235, 0.15);
  color: #2563eb;
}
.stat-card.stat-facility {
  border-color: #ea580c;
}
.stat-card.stat-facility .stat-icon {
  background: rgba(234, 88, 12, 0.15);
  color: #ea580c;
}
.stat-card.stat-facility:hover {
  border-color: #ea580c;
  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.2);
}
.stat-card.stat-drawing .stat-icon {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-icon i {
  font-size: 24px;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 800;
  color: #1e293b;
  line-height: 1;
}

.stat-unit {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  margin-left: 4px;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
  font-weight: 600;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 22px;
  font-weight: 800;
  color: #1e293b;
}
.section-title i {
  color: #ea580c;
}
.section-title .section-count {
  background: rgba(234, 88, 12, 0.15);
  color: #ea580c;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 700;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  background: #ea580c;
  border: none;
  border-radius: 14px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(234, 88, 12, 0.3);
}
.add-btn:hover {
  background: #d24f0b;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.4);
}
.add-btn.add-btn-secondary {
  background: #16a34a;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.3);
}
.add-btn.add-btn-secondary:hover {
  background: #138d40;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.4);
}

.facilities-section {
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.facility-card-item {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.facility-card-item:hover {
  border-color: #ea580c;
  box-shadow: 0 8px 24px rgba(234, 88, 12, 0.15);
  transform: translateY(-4px);
}
.facility-card-item:active {
  transform: scale(0.98);
}
.facility-card-item .card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.facility-card-item .card-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, rgba(234, 88, 12, 0.15) 0%, rgba(234, 88, 12, 0.08) 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.facility-card-item .card-icon i {
  font-size: 26px;
  color: #ea580c;
}
.facility-card-item .card-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #f1f5f9;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #475569;
}
.facility-card-item .card-badge i {
  font-size: 12px;
  color: #16a34a;
}
.facility-card-item .card-body {
  flex: 1;
}
.facility-card-item .card-title {
  font-size: 18px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 8px 0;
  line-height: 1.3;
}
.facility-card-item .card-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.facility-card-item .card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
.facility-card-item .inspect-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #2563eb;
}
.facility-card-item .inspect-label i {
  font-size: 14px;
}
.facility-card-item .card-footer > i {
  color: #2563eb;
  font-size: 16px;
}

.facility-card-placeholder {
  background: #f8fafc;
  border-radius: 20px;
  border: 2px dashed #e2e8f0;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.empty-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
}
.empty-message i {
  font-size: 20px;
}

.facilities-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.facility-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #fffbf7;
  border: 2px solid rgba(234, 88, 12, 0.3);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
}
.facility-card:hover {
  background: rgba(234, 88, 12, 0.08);
  border-color: #ea580c;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(234, 88, 12, 0.15);
}
.facility-card:active {
  transform: scale(0.98);
}

.facility-icon {
  width: 60px;
  height: 60px;
  background: rgba(234, 88, 12, 0.15);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.facility-icon i {
  font-size: 28px;
  color: #ea580c;
}

.facility-info {
  flex: 1;
  min-width: 0;
}

.facility-name {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.facility-meta .drawing-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 14px;
}
.facility-meta .drawing-count i {
  color: #64748b;
}

.facility-arrow {
  width: 40px;
  height: 40px;
  background: rgba(234, 88, 12, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.facility-arrow i {
  color: #ea580c;
  font-size: 16px;
}

.drawings-section {
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.drawings-section .section-title i {
  color: #16a34a;
}
.drawings-section .section-count {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
}

.drawings-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.drawing-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  transition: all 0.2s;
}
.drawing-item:hover {
  background: #f1f5f9;
  border-color: #d1dbe7;
}

.drawing-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.drawing-icon i {
  font-size: 22px;
}
.drawing-icon i.fa-file-pdf {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
}
.drawing-icon i.fa-image {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}

.drawing-info {
  flex: 1;
  min-width: 0;
}

.drawing-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.drawing-meta {
  font-size: 13px;
  color: #64748b;
}

.drawing-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}
.action-btn i {
  font-size: 18px;
}
.action-btn.download-btn {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}
.action-btn.download-btn:hover {
  background: #2563eb;
  color: #fff;
}
.action-btn.delete-btn {
  background: rgba(220, 38, 38, 0.1);
  color: rgba(220, 38, 38, 0.7);
}
.action-btn.delete-btn:hover {
  background: #dc2626;
  color: #fff;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}
.empty-state.empty-small {
  padding: 40px 20px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: #f1f5f9;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-icon i {
  font-size: 36px;
  color: #64748b;
}

.empty-text {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 20px;
}

.empty-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: #ea580c;
  border: none;
  border-radius: 14px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(234, 88, 12, 0.3);
}
.empty-add-btn:hover {
  background: #d24f0b;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.modal-content {
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #fafafa;
}

.modal-title-area {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modal-icon {
  width: 56px;
  height: 56px;
  background: rgba(234, 88, 12, 0.15);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-icon i {
  font-size: 24px;
  color: #ea580c;
}

.modal-title {
  font-size: 22px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 4px 0;
}

.modal-subtitle {
  font-size: 14px;
  color: #64748b;
}

.modal-close {
  width: 44px;
  height: 44px;
  background: #f1f5f9;
  border: none;
  border-radius: 12px;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;
}
.modal-close:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.modal-close i {
  font-size: 20px;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.detail-section {
  margin-bottom: 24px;
}
.detail-section:last-child {
  margin-bottom: 0;
}

.detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 12px;
}
.detail-label i {
  color: #64748b;
}
.detail-label .detail-count {
  background: rgba(234, 88, 12, 0.15);
  color: #ea580c;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 8px;
}

.detail-content {
  background: #f8fafc;
  border-radius: 14px;
  padding: 16px;
  color: #1e293b;
  font-size: 15px;
  line-height: 1.6;
  min-height: 60px;
  border: 1px solid #e2e8f0;
}

.photo-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.photo-section-guide {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.photo-section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.photo-unsaved {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.12);
  color: #d97706;
  font-size: 12px;
  font-weight: 700;
}

.photo-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}
.photo-action-btn:hover:not(:disabled) {
  border-color: #2563eb;
  color: #2563eb;
  background: rgba(37, 99, 235, 0.04);
}
.photo-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.facility-photo-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.facility-photo-card {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 14px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.facility-photo-preview {
  position: relative;
  min-height: 120px;
  border-radius: 14px;
  overflow: hidden;
  background: #e2e8f0;
}
.facility-photo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.facility-photo-remove {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: rgba(220, 38, 38, 0.92);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}
.facility-photo-remove:hover {
  background: #dc2626;
}

.facility-photo-form {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.facility-photo-field-label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
}

.facility-photo-name {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #1e293b;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.facility-photo-name:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.facility-photo-file {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.facility-photo-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 28px 18px;
  border-radius: 14px;
  border: 1px dashed #c7d3e2;
  background: #f8fafc;
  color: #64748b;
  font-size: 14px;
}
.facility-photo-empty i {
  font-size: 18px;
}

.drawing-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  background: #f8fafc;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
}

.loading-spinner-small i {
  font-size: 20px;
  color: #2563eb;
}

.drawing-select-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.drawing-select-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 14px;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
}
.drawing-select-item:hover {
  background: #f1f5f9;
  border-color: #c0cddf;
}
.drawing-select-item.selected {
  background: rgba(37, 99, 235, 0.08);
  border-color: #2563eb;
}
.drawing-select-item.selected .radio-inner {
  transform: scale(1);
}
.drawing-select-item.selected .select-drawing-name {
  color: #2563eb;
}
.drawing-select-item:active {
  transform: scale(0.99);
}

.select-radio {
  flex-shrink: 0;
}

.radio-outer {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.drawing-select-item.selected .radio-outer {
  border-color: #2563eb;
}

.radio-inner {
  width: 12px;
  height: 12px;
  background: #2563eb;
  border-radius: 50%;
  transform: scale(0);
  transition: transform 0.2s ease;
}

.select-drawing-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.select-drawing-icon i {
  font-size: 20px;
}
.select-drawing-icon i.fa-file-pdf {
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}
.select-drawing-icon i.fa-image {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.select-drawing-info {
  flex: 1;
  min-width: 0;
}

.select-drawing-name {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
  transition: color 0.2s;
}

.select-drawing-size {
  font-size: 13px;
  color: #64748b;
}

.linked-drawings {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.linked-drawing-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.linked-drawing-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.linked-drawing-icon i {
  font-size: 18px;
}
.linked-drawing-icon i.fa-file-pdf {
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.linked-drawing-icon i.fa-image {
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.linked-drawing-info {
  flex: 1;
  min-width: 0;
}

.linked-drawing-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.linked-drawing-size {
  font-size: 12px;
  color: #64748b;
}

.linked-download-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: #2563eb;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.linked-download-btn:hover {
  background: #1d4ed8;
}

.empty-linked {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
  background: #f8fafc;
  border-radius: 14px;
  color: #64748b;
  font-size: 14px;
  border: 1px solid #e2e8f0;
}
.empty-linked i {
  font-size: 24px;
  color: #64748b;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  background: #fafafa;
}

.modal-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}
.modal-btn.btn-secondary {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}
.modal-btn.btn-secondary:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.modal-btn.btn-primary {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}
.modal-btn.btn-primary:hover {
  background: #1d4ed8;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: #64748b;
}

.loading-spinner {
  margin-bottom: 16px;
}
.loading-spinner i {
  font-size: 48px;
  color: #2563eb;
}

.loading-text {
  font-size: 18px;
  color: #475569;
}

@media (min-width: 900px) and (max-width: 1200px) {
  .field-detail-page {
    padding: 14px;
    padding-bottom: 24px;
  }
  .compact-header {
    padding: 12px 18px;
    margin-bottom: 10px;
  }
  .project-name {
    font-size: 18px;
  }
  .back-icon-btn {
    width: 40px;
    height: 40px;
  }
  .chip {
    padding: 3px 8px;
    font-size: 11px;
  }
  .mini-stat {
    padding: 6px 10px;
    font-size: 14px;
  }
  .offline-cache-panel {
    padding: 10px 12px;
    margin-bottom: 10px;
  }
  .offline-cache-main {
    grid-template-columns: 40px minmax(0, 1fr) auto;
    gap: 10px;
  }
  .offline-cache-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }
  .offline-cache-title {
    font-size: 14px;
  }
  .offline-cache-summary,
  .offline-cache-updated {
    font-size: 12px;
  }
  .offline-cache-progress {
    margin-top: 6px;
  }
  .cache-action-btn {
    height: 34px;
    padding: 0 10px;
    font-size: 12px;
  }
  .facility-main-section {
    padding: 14px 16px;
    border-radius: 16px;
  }
  .facility-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
  }
  .facility-title {
    font-size: 16px;
  }
  .facility-cards {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 12px;
    min-height: 340px;
  }
  .facility-card-item {
    gap: 10px;
    padding: 14px;
    border-radius: 16px;
  }
  .facility-card-item:active {
    transform: scale(0.97);
  }
  .facility-card-item .card-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
  }
  .facility-card-item .card-icon i {
    font-size: 22px;
  }
  .facility-card-item .card-badge {
    padding: 6px 10px;
    font-size: 12px;
  }
  .facility-card-item .card-title {
    font-size: 16px;
    margin-bottom: 4px;
  }
  .facility-card-item .card-desc {
    font-size: 13px;
    -webkit-line-clamp: 1;
  }
  .facility-card-item .card-footer {
    padding-top: 10px;
  }
  .facility-card-item .inspect-label {
    font-size: 14px;
  }
  .pagination-controls {
    margin-top: 12px;
    padding-top: 10px;
  }
  .page-btn, .page-num {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
}
@media (min-width: 900px) and (max-height: 920px) and (orientation: landscape) {
  .field-detail-page {
    padding: 14px;
    padding-bottom: 24px;
  }
  .compact-header {
    padding: 12px 18px;
    margin-bottom: 10px;
  }
  .project-name {
    font-size: 18px;
  }
  .offline-cache-panel {
    padding: 10px 12px;
    margin-bottom: 10px;
  }
  .offline-cache-progress {
    margin-top: 6px;
  }
  .facility-main-section {
    padding: 14px 16px;
    border-radius: 16px;
  }
  .facility-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
  }
  .facility-cards {
    gap: 12px;
    min-height: 340px;
  }
  .facility-card-item {
    gap: 10px;
    padding: 14px;
    border-radius: 16px;
  }
  .facility-card-item .card-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
  }
  .facility-card-item .card-icon i {
    font-size: 22px;
  }
  .facility-card-item .card-badge {
    padding: 6px 10px;
    font-size: 12px;
  }
  .facility-card-item .card-title {
    font-size: 16px;
    margin-bottom: 4px;
  }
  .facility-card-item .card-desc {
    font-size: 13px;
    -webkit-line-clamp: 1;
  }
  .facility-card-item .card-footer {
    padding-top: 10px;
  }
  .facility-card-item .inspect-label {
    font-size: 14px;
  }
  .pagination-controls {
    margin-top: 12px;
    padding-top: 10px;
  }
  .page-btn,
  .page-num {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
}
@media (min-width: 768px) and (max-width: 899px) {
  .field-detail-page {
    padding: 16px;
  }
  .compact-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
  }
  .header-left {
    gap: 12px;
  }
  .header-right {
    justify-content: flex-end;
  }
  .project-name {
    font-size: 20px;
  }
  .offline-cache-panel {
    grid-template-columns: 1fr;
  }
  .offline-cache-actions {
    justify-content: flex-end;
  }
  .facility-cards {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 14px;
    min-height: 340px;
  }
  .facility-card-item {
    padding: 20px;
  }
  .facility-card-item:active {
    transform: scale(0.97);
  }
  .facility-card-item .card-icon {
    width: 50px;
    height: 50px;
  }
  .facility-card-item .card-icon i {
    font-size: 24px;
  }
  .facility-card-item .card-title {
    font-size: 17px;
  }
  .page-btn, .page-num {
    width: 50px;
    height: 50px;
    font-size: 16px;
  }
  .modal-content {
    max-width: 90%;
    max-height: 85vh;
  }
  .modal-btn {
    padding: 18px 24px;
    font-size: 17px;
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .field-detail-page {
    padding: 14px;
  }
  .compact-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 14px;
    border-radius: 14px;
  }
  .project-name {
    font-size: 18px;
  }
  .project-chips {
    gap: 6px;
  }
  .chip {
    padding: 3px 8px;
    font-size: 11px;
  }
  .header-right {
    justify-content: flex-end;
  }
  .mini-stat {
    padding: 6px 12px;
    font-size: 14px;
  }
  .offline-cache-panel {
    grid-template-columns: 1fr;
  }
  .offline-cache-actions {
    justify-content: stretch;
  }
  .cache-action-btn {
    flex: 1;
  }
  .facility-main-section {
    padding: 16px;
    border-radius: 16px;
  }
  .facility-cards {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 12px;
    min-height: 320px;
  }
  .facility-card-item {
    padding: 16px;
    border-radius: 16px;
  }
  .facility-card-item .card-icon {
    width: 46px;
    height: 46px;
  }
  .facility-card-item .card-icon i {
    font-size: 24px;
  }
  .facility-card-item .card-title {
    font-size: 17px;
  }
  .facility-card-item .card-desc {
    font-size: 13px;
  }
  .page-btn, .page-num {
    width: 46px;
    height: 46px;
  }
}
@media (max-width: 599px) {
  .field-detail-page {
    padding: 12px;
    padding-bottom: 30px;
  }
  .compact-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 12px;
  }
  .back-icon-btn {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  .project-name {
    font-size: 16px;
  }
  .project-chips {
    gap: 4px;
  }
  .chip {
    padding: 2px 6px;
    font-size: 10px;
    border-radius: 4px;
  }
  .header-right {
    justify-content: flex-end;
  }
  .mini-stat {
    padding: 5px 10px;
    font-size: 13px;
    border-radius: 8px;
  }
  .facility-main-section {
    padding: 14px;
    border-radius: 14px;
  }
  .facility-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 14px;
    padding-bottom: 12px;
  }
  .facility-title {
    font-size: 16px;
  }
  .facility-title i {
    font-size: 18px;
  }
  .facility-cards {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
    gap: 10px;
    min-height: 500px;
  }
  .facility-card-item {
    padding: 16px;
    border-radius: 14px;
  }
  .facility-card-item .card-icon {
    width: 44px;
    height: 44px;
  }
  .facility-card-item .card-icon i {
    font-size: 20px;
  }
  .facility-card-item .card-badge {
    padding: 6px 10px;
    font-size: 12px;
  }
  .facility-card-item .card-title {
    font-size: 15px;
  }
  .facility-card-item .card-desc {
    font-size: 12px;
    -webkit-line-clamp: 1;
  }
  .facility-card-item .card-footer {
    padding-top: 12px;
  }
  .facility-card-item .inspect-label {
    font-size: 14px;
  }
  .pagination-controls {
    gap: 4px;
    margin-top: 16px;
    padding-top: 12px;
  }
  .page-btn {
    width: 40px;
    height: 40px;
    border-radius: 8px;
  }
  .page-numbers {
    gap: 3px;
  }
  .page-num {
    min-width: 36px;
    height: 40px;
    font-size: 14px;
    border-radius: 8px;
  }
  .modal-overlay {
    padding: 0;
  }
  .modal-content {
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
    height: 100vh;
  }
  .photo-section-header {
    flex-direction: column;
  }
  .photo-section-actions {
    width: 100%;
    justify-content: stretch;
  }
  .photo-action-btn {
    flex: 1;
  }
  .facility-photo-card {
    grid-template-columns: 1fr;
  }
  .facility-photo-preview {
    min-height: 180px;
  }
  .offline-cache-panel {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .offline-cache-main {
    grid-template-columns: 44px minmax(0, 1fr);
  }
  .offline-cache-meta {
    grid-column: 1/-1;
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
  .offline-cache-actions {
    justify-content: stretch;
  }
  .cache-action-btn {
    flex: 1;
  }
  .offline-cache-categories {
    grid-template-columns: 1fr;
  }
  .offline-cache-category {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .offline-cache-category .category-size {
    display: none;
  }
  .missing-item {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
  .missing-item small {
    white-space: normal;
  }
}`],
})
export class PageProjectDetailComponent implements OnInit {
    public project: any = null;
    public drawings: any[] = [];
    public facilities: any[] = [];
    public id: string = '';

    // 페이지네이션
    public currentPage: number = 1;
    public itemsPerPage: number = 4;

    // Modal states
    public showDrawingModal: boolean = false;
    public showFacilityModal: boolean = false;
    public showFacilityDetail: boolean = false;
    
    // 시설물 상세 관련
    public selectedFacility: any = null;
    public linkedDrawings: any[] = [];
    public selectedDrawingId: string | null = null;
    public isLoadingDrawings: boolean = false;
    public isSavingFacilityOverviewPhotos: boolean = false;
    public facilityOverviewPhotosDirty: boolean = false;
    public cacheManifest: any = null;
    public prefetching: boolean = false;
    public prefetchProgress: any = { current: 0, total: 0, label: '' };
    public showCacheDetails: boolean = false;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        this.id = WizRoute.segment.id || '';
        await this.load();
        await this.loadCacheManifest();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    // Load project detail
    public async load() {
        const { code, data } = await wiz.call("detail", { id: this.id });
        if (code === 200) {
            this.project = data.project || null;
            this.drawings = data.drawings || [];
            this.facilities = data.facilities || [];
        } else {
            await this.service.alert.show({
                title: '오류',
                message: '용역 정보를 불러올 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.service.href('/project/list');
        }
        this.ref.detectChanges();
    }

    // Calculate days
    public calculateDays(): number {
        if (!this.project?.start_date || !this.project?.end_date) return 0;
        const start = new Date(this.project.start_date);
        const end = new Date(this.project.end_date);
        const diff = end.getTime() - start.getTime();
        return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
    }

    // Get participant count
    public getParticipantCount(): number {
        if (!this.project?.participants) return 0;
        return this.project.participants.split(',').filter((p: string) => p.trim()).length;
    }

    // Format date
    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    // Format file size
    public formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    public async loadCacheManifest() {
        try {
            if (!wiz.offline?.prefetch || !this.id) return;
            this.cacheManifest = await wiz.offline.prefetch.getManifest(this.id);
        } catch (error) {
            console.warn('Cache manifest load failed:', error);
            this.cacheManifest = null;
        }
        if (!this.hasCacheDetails()) this.showCacheDetails = false;
        this.ref.detectChanges();
    }

    public getCacheStatusLabel(): string {
        if (this.prefetching) return '다운로드 중';
        if (!this.cacheManifest) return '미준비';
        if (this.cacheManifest.status === 'completed') {
            return this.getOptionalIssueCount() > 0 ? '오프라인 진단 가능' : '오프라인 가능';
        }
        if (this.cacheManifest.status === 'failed') return '실패';
        if (this.cacheManifest.status === 'partial') return '일부 누락';
        return '준비 중';
    }

    public getCacheStatusClass(): string {
        if (this.prefetching) return 'syncing';
        if (!this.cacheManifest) return 'missing';
        return this.cacheManifest.status || 'missing';
    }

    public getCacheSummaryText(): string {
        if (this.prefetching) {
            const current = this.prefetchProgress.current || 0;
            const total = this.prefetchProgress.total || 0;
            const label = this.prefetchProgress.label || '캐시 준비';
            return `${label} (${current}/${total})`;
        }
        if (!this.cacheManifest) return '프로젝트 사전 다운로드 기록이 없습니다.';
        const total = this.cacheManifest.total_items || 0;
        const cached = this.cacheManifest.cached_items || 0;
        const requiredTotal = this.getRequiredTotal();
        const requiredCached = this.getRequiredCached();
        const requiredIssues = this.getRequiredIssueCount();
        const optionalIssues = this.getOptionalIssueCount();
        const base = requiredTotal > 0
            ? `필수 ${requiredCached}/${requiredTotal}개 완료`
            : `${cached}/${total}개 완료`;
        const optionalText = optionalIssues > 0 ? ` · 선택 export ${optionalIssues}개 미준비` : '';
        if (requiredIssues > 0) return `${base}, 필수 ${requiredIssues}개 확인 필요${optionalText}`;
        return `${base} · 진단 가능${optionalText}`;
    }

    public getCacheCompletionPercent(): number {
        if (!this.cacheManifest) return 0;
        const total = this.getRequiredTotal();
        if (!total) return 0;
        return Math.round(this.getRequiredCached() * 100 / total);
    }

    public getCacheCategories(): any[] {
        if (!this.cacheManifest || !Array.isArray(this.cacheManifest.categories)) return [];
        return this.cacheManifest.categories;
    }

    public getCacheCategoryText(category: any): string {
        const unavailable = Number(category.failed || 0) + Number(category.missing || 0) + Number(category.pending || 0);
        const required = Number(category.required || 0);
        const optional = Number(category.optional || 0);
        if (required === 0 && optional > 0) {
            if (unavailable > 0) return `${category.cached}/${category.total} 준비 · 선택 ${unavailable}개 미준비`;
            return `${category.cached}/${category.total} 준비`;
        }
        if (unavailable > 0) return `${category.cached}/${category.total} 완료 · 필수 ${unavailable}개 확인`;
        return `${category.cached}/${category.total} 완료`;
    }

    public getCacheMissingPreview(): any[] {
        return this.getCacheBlockingPreview();
    }

    public getCacheBlockingPreview(): any[] {
        if (!this.cacheManifest || !Array.isArray(this.cacheManifest.items)) return [];
        return this.cacheManifest.items
            .filter((item: any) => this.isRequiredCacheItem(item) && this.isUnavailableCacheItem(item))
            .slice(0, 5);
    }

    public getCacheOptionalPreview(): any[] {
        if (!this.cacheManifest || !Array.isArray(this.cacheManifest.items)) return [];
        return this.cacheManifest.items
            .filter((item: any) => !this.isRequiredCacheItem(item) && this.isUnavailableCacheItem(item))
            .slice(0, 5);
    }

    public hasCacheDetails(): boolean {
        return this.getCacheCategories().length > 0
            || this.getCacheBlockingPreview().length > 0
            || this.getCacheOptionalPreview().length > 0;
    }

    public toggleCacheDetails() {
        this.showCacheDetails = !this.showCacheDetails;
        this.ref.detectChanges();
    }

    public getCacheUpdatedText(): string {
        if (!this.cacheManifest?.updated_at) return '-';
        try {
            return new Date(this.cacheManifest.updated_at).toLocaleString('ko-KR', {
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return '-';
        }
    }

    public async startOfflinePrefetch() {
        if (this.prefetching || !this.id) return;
        if (wiz.offline?.isOffline && wiz.offline.isOffline()) {
            await this.service.alert.show({
                title: '온라인 연결 필요',
                message: '사전 다운로드는 네트워크가 연결된 상태에서만 실행할 수 있습니다.',
                status: 'warning',
                action: '확인',
                cancel: false
            });
            return;
        }

        this.prefetching = true;
        this.prefetchProgress = { current: 0, total: 0, label: '준비 중' };
        const unsubscribe = wiz.offline.prefetch.onProgress((progress: any) => {
            this.prefetchProgress = progress;
            this.ref.detectChanges();
        });
        this.ref.detectChanges();

        try {
            await wiz.offline.prefetch.prefetchProject(this.id);
            await this.loadCacheManifest();
            const blockingCount = this.getRequiredIssueCount();
            const optionalCount = this.getOptionalIssueCount();
            await this.service.alert.show({
                title: blockingCount > 0 ? '캐시 확인 필요' : (optionalCount > 0 ? '오프라인 진단 가능' : '오프라인 캐시 완료'),
                message: blockingCount > 0
                    ? '진단에 필요한 일부 캐시가 누락되었거나 실패했습니다. 필수 캐시 확인 항목을 확인하세요.'
                    : (optionalCount > 0
                        ? '도면/시설물/체크리스트 캐시는 준비되었습니다. export 산출물은 온라인에서 한 번 추출한 뒤 오프라인에서 사용할 수 있습니다.'
                        : '프로젝트 오프라인 캐시가 완료되었습니다.'),
                status: blockingCount > 0 ? 'warning' : 'success',
                action: '확인',
                cancel: false
            });
        } catch (e: any) {
            await this.service.alert.show({
                title: '사전 다운로드 실패',
                message: e?.message || '오프라인 캐시를 준비하지 못했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        } finally {
            unsubscribe();
            this.prefetching = false;
            await this.loadCacheManifest();
            this.ref.detectChanges();
        }
    }

    private getRequiredTotal(): number {
        return Number(this.cacheManifest?.required_items ?? this.cacheManifest?.total_items ?? 0);
    }

    private getRequiredCached(): number {
        return Number(this.cacheManifest?.required_cached_items ?? this.cacheManifest?.cached_items ?? 0);
    }

    private getRequiredIssueCount(): number {
        if (!this.cacheManifest) return 0;
        const explicit = Number(this.cacheManifest.blocking_items ?? NaN);
        if (!Number.isNaN(explicit)) return explicit;
        return this.cacheManifest.items
            .filter((item: any) => this.isRequiredCacheItem(item) && this.isUnavailableCacheItem(item))
            .length;
    }

    private getOptionalIssueCount(): number {
        if (!this.cacheManifest) return 0;
        const explicit = Number(this.cacheManifest.optional_unavailable_items ?? NaN);
        if (!Number.isNaN(explicit)) return explicit;
        return this.cacheManifest.items
            .filter((item: any) => !this.isRequiredCacheItem(item) && this.isUnavailableCacheItem(item))
            .length;
    }

    private isRequiredCacheItem(item: any): boolean {
        if (typeof item?.required === 'boolean') return item.required;
        if (item?.requirement === 'optional') return false;
        return item?.category !== 'export';
    }

    private isUnavailableCacheItem(item: any): boolean {
        return item?.status === 'failed' || item?.status === 'missing' || item?.status === 'pending';
    }

    private generateId(): string {
        return Date.now().toString(36) + Math.random().toString(36).slice(2, 9);
    }

    private stripFileExtension(name: string): string {
        return String(name || '').replace(/\.[^/.]+$/, '');
    }

    private normalizeFacilityOverviewPhotos(photos: any): any[] {
        if (!Array.isArray(photos)) return [];

        return photos
            .filter((photo: any) => photo && typeof photo === 'object' && typeof photo.data === 'string' && photo.data.startsWith('data:image/'))
            .map((photo: any, index: number) => ({
                id: photo.id || this.generateId(),
                name: photo.name || `facility_photo_${index + 1}`,
                locationName: photo.locationName || '',
                data: photo.data,
                timestamp: photo.timestamp || new Date().toISOString()
            }));
    }

    public getFacilityOverviewPhotos(): any[] {
        return Array.isArray(this.selectedFacility?.overviewPhotos) ? this.selectedFacility.overviewPhotos : [];
    }

    public getFacilityOverviewPhotoCount(): number {
        return this.getFacilityOverviewPhotos().length;
    }

    public trackFacilityOverviewPhoto(index: number, photo: any): string {
        return photo?.id || String(index);
    }

    private setFacilityOverviewPhotos(photos: any[], markDirty: boolean = true) {
        if (!this.selectedFacility) return;

        this.selectedFacility = {
            ...this.selectedFacility,
            overviewPhotos: this.normalizeFacilityOverviewPhotos(photos)
        };
        this.facilityOverviewPhotosDirty = markDirty;
        this.ref.detectChanges();
    }

    // Check if PDF
    public isPdf(drawing: any): boolean {
        const filename = drawing.filename || drawing.filepath || '';
        return filename.toLowerCase().endsWith('.pdf');
    }

    // Back to list
    public goBack() {
        this.service.href('/inspection');
    }

    // ========== 페이지네이션 ==========
    get paginatedFacilities(): any[] {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.facilities.slice(start, end);
    }

    get totalPages(): number {
        return Math.ceil(this.facilities.length / this.itemsPerPage);
    }

    get visiblePages(): number[] {
        const pages: number[] = [];
        const total = this.totalPages;
        if (total === 0) return pages;
        
        const current = this.currentPage;
        
        let start = Math.max(1, current - 2);
        let end = Math.min(total, current + 2);
        
        if (end - start < 4) {
            if (start === 1) end = Math.min(total, 5);
            else start = Math.max(1, total - 4);
        }
        
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    // 빈 카드 슬롯 (4개 채우기용)
    get emptySlots(): number[] {
        const currentCount = this.paginatedFacilities.length;
        const emptyCount = this.itemsPerPage - currentCount;
        if (emptyCount <= 0) return [];
        return Array(emptyCount).fill(0).map((_, i) => i);
    }

    public getCurrentPageStart(): number {
        if (this.facilities.length === 0) return 0;
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    public getCurrentPageEnd(): number {
        return Math.min(this.currentPage * this.itemsPerPage, this.facilities.length);
    }

    public goToPage(page: number) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            this.ref.detectChanges();
        }
    }

    public prevPage() {
        if (this.currentPage > 1) this.goToPage(this.currentPage - 1);
    }

    public nextPage() {
        if (this.currentPage < this.totalPages) this.goToPage(this.currentPage + 1);
    }

    // Scroll to facilities section
    public scrollToFacilities() {
        const el = document.getElementById('facilities-section');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // ========== Drawing Modal ==========
    public openDrawingModal() {
        this.showDrawingModal = true;
        this.ref.detectChanges();
    }

    public closeDrawingModal() {
        this.showDrawingModal = false;
        this.ref.detectChanges();
    }

    // Delete drawing with confirmation
    public async confirmDeleteDrawing(event: Event, drawing: any) {
        event.stopPropagation();
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 도면을 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;
        await this.deleteDrawing(drawing);
    }

    // Delete drawing
    public async deleteDrawing(drawing: any) {
        await this.service.loading.show();
        const { code } = await wiz.call("delete_drawing", { id: drawing.id });
        await this.service.loading.hide();

        if (code === 200) {
            await this.load();
        }
    }

    // Download drawing
    public downloadDrawing(drawing: any) {
        const url = wiz.url('download') + '?id=' + drawing.id;
        const link = document.createElement('a');
        link.href = url;
        link.download = drawing.filename || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // ========== Facility Modal ==========
    public openFacilityModal() {
        this.showFacilityModal = true;
        this.ref.detectChanges();
    }

    public closeFacilityModal() {
        this.showFacilityModal = false;
        this.ref.detectChanges();
    }

    // ========== Facility Detail Modal ==========
    public async openFacilityDetail(facility: any) {
        const openedFacilityId = facility?.id;
        this.selectedFacility = {
            ...facility,
            overviewPhotos: this.normalizeFacilityOverviewPhotos(facility?.overviewPhotos)
        };
        this.linkedDrawings = [];
        this.selectedDrawingId = null;
        this.isLoadingDrawings = true;
        this.facilityOverviewPhotosDirty = false;
        this.showFacilityDetail = true;
        this.ref.detectChanges();

        // 연결된 도면 로드
        const { code, data } = await wiz.call("get_facility_detail", { id: facility.id });
        if (!this.showFacilityDetail || this.selectedFacility?.id !== openedFacilityId) return;
        this.isLoadingDrawings = false;
        if (code === 200) {
            this.selectedFacility = {
                ...this.selectedFacility,
                ...(data.facility || {}),
                overviewPhotos: this.normalizeFacilityOverviewPhotos(data.overview_photos || [])
            };
            this.linkedDrawings = data.drawings || [];
            // 도면이 1개면 자동 선택
            if (this.linkedDrawings.length === 1) {
                this.selectedDrawingId = this.linkedDrawings[0].id;
            }
        }
        this.facilityOverviewPhotosDirty = false;
        this.ref.detectChanges();
    }

    public selectDrawing(drawing: any) {
        this.selectedDrawingId = drawing.id;
        this.ref.detectChanges();
    }

    public async closeFacilityDetail() {
        if (this.isSavingFacilityOverviewPhotos) return;

        if (this.facilityOverviewPhotosDirty) {
            const discard = await this.service.alert.show({
                title: '저장되지 않은 사진',
                message: '저장하지 않은 시설물 전경사진 변경사항이 있습니다. 닫으시겠습니까?',
                status: 'warning',
                action: '닫기',
                cancel: '계속 편집'
            });
            if (!discard) return;
        }

        this.showFacilityDetail = false;
        this.selectedFacility = null;
        this.linkedDrawings = [];
        this.selectedDrawingId = null;
        this.facilityOverviewPhotosDirty = false;
        this.ref.detectChanges();
    }

    public triggerFacilityOverviewPhotoCapture() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';
        input.multiple = true;
        input.onchange = (event: any) => {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            for (let index = 0; index < files.length; index++) {
                this.processFacilityOverviewPhoto(files[index]);
            }
        };
        input.click();
    }

    private processFacilityOverviewPhoto(file: File) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            const nextPhotos = [...this.getFacilityOverviewPhotos()];
            nextPhotos.push({
                id: this.generateId(),
                name: file.name,
                locationName: this.stripFileExtension(file.name),
                data: event.target.result,
                timestamp: new Date().toISOString()
            });
            this.setFacilityOverviewPhotos(nextPhotos, true);
        };
        reader.readAsDataURL(file);
    }

    public updateFacilityOverviewPhotoLocation(photoId: string, value: string) {
        const target = this.getFacilityOverviewPhotos().find((photo: any) => photo.id === photoId);
        if (!target) return;
        target.locationName = value;
        this.facilityOverviewPhotosDirty = true;
        this.ref.detectChanges();
    }

    public removeFacilityOverviewPhoto(photoId: string) {
        const nextPhotos = this.getFacilityOverviewPhotos().filter((photo: any) => photo.id !== photoId);
        this.setFacilityOverviewPhotos(nextPhotos, true);
    }

    public async saveFacilityOverviewPhotos(showAlert: boolean = true): Promise<boolean> {
        if (!this.selectedFacility?.id || this.isSavingFacilityOverviewPhotos) return false;

        this.isSavingFacilityOverviewPhotos = true;
        await this.service.loading.show();

        const fd = new FormData();
        fd.append('id', this.selectedFacility.id);
        fd.append('photos', JSON.stringify(this.getFacilityOverviewPhotos()));

        let savedPhotos: any[] = [];
        let errorMessage = '';

        try {
            const response = await fetch(wiz.url('save_facility_overview_photos'), {
                method: 'POST',
                body: fd,
                credentials: 'include'
            });
            const result = await response.json();

            if (response.status !== 200) {
                throw new Error(result?.message || result?.data || '시설물 전경사진 저장에 실패했습니다.');
            }

            savedPhotos = this.normalizeFacilityOverviewPhotos(result?.data?.photos || result?.photos || []);
        } catch (e: any) {
            errorMessage = e?.message || '시설물 전경사진 저장에 실패했습니다.';
        }

        await this.service.loading.hide();
        this.isSavingFacilityOverviewPhotos = false;

        if (errorMessage) {
            await this.service.alert.show({
                title: '오류',
                message: errorMessage,
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.ref.detectChanges();
            return false;
        }

        this.selectedFacility = {
            ...this.selectedFacility,
            overviewPhotos: savedPhotos
        };
        this.facilityOverviewPhotosDirty = false;

        if (showAlert) {
            await this.service.alert.show({
                title: '성공',
                message: '시설물 전경사진이 저장되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
        }

        this.ref.detectChanges();
        return true;
    }

    // Start inspection with selected drawing
    public async startInspectionWithDrawing() {
        if (!this.selectedFacility) return;
        
        if (this.linkedDrawings.length > 0 && !this.selectedDrawingId) {
            this.service.alert.show({
                title: '도면 선택',
                message: '점검할 도면을 선택해주세요.',
                status: 'warning',
                action: '확인',
                cancel: false
            });
            return;
        }

        if (this.facilityOverviewPhotosDirty) {
            const saved = await this.saveFacilityOverviewPhotos(false);
            if (!saved) return;
        }
        
        // 점검 시작 페이지로 이동
        const facilityId = this.selectedFacility.id;
        if (this.selectedDrawingId) {
            this.service.href(`/inspection/facility/${facilityId}/drawing/${this.selectedDrawingId}`);
        } else {
            this.service.href(`/inspection/facility/${facilityId}`);
        }
    }

    // Start inspection for facility (legacy)
    public startInspection(facility: any) {
        // 점검 시작 페이지로 이동 (추후 구현)
        this.service.href(`/inspection/facility/${facility.id}`);
    }

    // Delete facility
    public async deleteFacility(facility: any) {
        await this.service.loading.show();
        const { code } = await wiz.call("delete_facility", { id: facility.id });
        await this.service.loading.hide();

        if (code === 200) {
            await this.load();
        }
    }
}

export default PageProjectDetailComponent;